'use client';

import Image from 'next/image';
import Link from 'next/link';

import { useGTMPromotionBanner } from '@/fo/api/gtm';
import { UiAdvertisingInformerBase } from '@/fo/ui/advertising/informer/base';

import { styles } from './UiKitBannerTextRight.styles';

type NativeElement = React.HTMLAttributes<HTMLDivElement>;
export interface UiKitBannerTextRightProps {
  className?: string;
  title: React.ReactNode;
  text: React.ReactNode;
  alt?: string;
  image: string;
  link?: string;
  promotionName?: string;
  onClick?: NativeElement['onClick'];
  erid?: string;
  advertisingWarningText?: string;
}

export function UiKitBannerTextRight({
  className,
  title,
  text,
  image,
  link,
  promotionName = '',
  erid,
  advertisingWarningText,
  alt = '',
  ...props
}: UiKitBannerTextRightProps) {
  const slots = styles();
  const { ref, trackSelectPromotion } = useGTMPromotionBanner({
    creativeName: image,
    promotionId: link || '',
    promotionName,
    source: 'static',
    index: 1
  });

  const imageNode = (
    <Image
      alt={alt}
      height={300}
      src={image}
      width={517}
    />
  );

  return (
    <div
      ref={ref}
      className={slots.base({ className })}
      {...props}
    >
      <div className={slots.section()}>
        <div className={slots.container()}>
          <div className={slots.imageWrap()}>
            {link ? (
              <Link
                href={link}
                onClick={trackSelectPromotion}
              >
                {imageNode}
              </Link>
            ) : (
              imageNode
            )}
          </div>
          <div className={slots.body()}>
            <div className={slots.title()}>{title}</div>
            <p className={slots.text()}>{text}</p>
          </div>
        </div>
        {erid && (
          <UiAdvertisingInformerBase
            className={slots.advertisingInformer()}
            classNameContent={slots.advertisingInformerContent()}
            erid={erid || ''}
            advertisingWarningText={advertisingWarningText}
          />
        )}
      </div>
    </div>
  );
}
